import noEventsButtonsWidget from './noEventsButtonsWidget';

export default function () {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;

  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    detectIpad: IPADDETECTED,
    isResponsive: false,
    // options
    allEventsLink: true,
    allEventsLinkText: 'VIEW ALL EVENTS',
    hasImages: false,
    imageBackground: false,
    lazyLoadImages: true,
    buyNowButton: false,
    moreButton: false,
    maxItemsVisible: 5,
    hasDescription: true,
    textContainer: true,
    link: 'all',
    attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons',
    },
    multiFeatureLoaded: function (data) {
      const widgetItems = data.length;

      if (widgetItems >= 1) {
        $('#noEventsButtonsWidget').remove();
        $(`#${widgetName} .featureItem`).each(function (x) {
          const itemDescripton = $(this).find('.featureItemDescription');
          const eventDate = $(this).find('.featureItemDate');
          const eventDateText = formatDate(eventDate.text());
          eventDate.html('<span class="featureItemDate-text">' + eventDateText + '</span>');
          itemDescripton.remove();

          if (data[x].URL == '') {
            $(this).addClass('void-link');
            $(this).removeAttr('href');
          }
        });
        $(`#${widgetName}`).prepend(`<h2>Upcoming <strong>Events<strong></h2>`);
      } else {
        $(`#${widgetName}`).remove();
        noEventsButtonsWidget();
      }
    },
  });
}

function formatDate(dateString) {
  const dateParts = dateString.slice(0, -6).split(' - ');
  // remove the last 4 characters (year) from the date string
  const startDate = dateParts[0];
  const endDate = dateParts[1] ? dateParts[1] : '';
  let formatDate = '';

  if (endDate) {
    const [startMonth] = startDate.split(' ');
    const [endMonth, endDay] = endDate.split(' ');
    if (startMonth !== endMonth) {
      formatDate = ` ${startDate} - ${endMonth} ${endDay}`; // Different month
    } else {
      formatDate = ` ${startDate} - ${endDay}`; // Same month
    }
  } else {
    formatDate = ` ${startDate}`; // Single day
  }
  return formatDate;
}
